export default __webpack_public_path__ + "static/1156-21eaba8bfb22a63472cfd0232c64f98c.gif";